import * as XLSX from "xlsx";

/**
 * Exports JSON data to an Excel file. Fully reusable.
 * @param {Array} data - Array of objects to export.
 * @param {string} fileName - Name of the exported Excel file.
 * @param {string} sheetName - Name of the worksheet.
 */
export const exportToExcel = (data, fileName = "Reporte.xlsx", sheetName = "Sheet") => {
    if (!data || !data.length) {
        console.error("No data to export.");
        return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    XLSX.writeFile(workbook, fileName);
};